/**
 * @generated SignedSource<<849303422b07f5046ecab5e75bbdd1c3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventCompetitionsFragment$data = {
  readonly competitions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly competition: {
          readonly id: string;
          readonly isPrivate: boolean;
          readonly slug: string;
          readonly title: string;
          readonly " $fragmentSpreads": FragmentRefs<"CompetitionCardFragment">;
        };
        readonly id: string;
        readonly membersCanReadEvent: boolean;
        readonly viewerCanDelete: boolean;
      };
    }>;
  };
  readonly id: string;
  readonly isPrivate: boolean;
  readonly slug: string;
  readonly viewerCanCreateEventFromCompetition: boolean;
  readonly viewerCanUpdate: boolean;
  readonly " $fragmentType": "EventCompetitionsFragment";
};
export type EventCompetitionsFragment$key = {
  readonly " $data"?: EventCompetitionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCompetitionsFragment">;
};

import EventCompetitionsFragmentPaginationQuery_graphql from './EventCompetitionsFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "competitions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": EventCompetitionsFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "EventCompetitionsFragment",
  "selections": [
    (v1/*:: as any*/),
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": "viewerCanCreateEventFromCompetition",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_EVENT"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_EVENT\")"
    },
    {
      "alias": "viewerCanUpdate",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_EVENT"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_EVENT\")"
    },
    {
      "alias": "competitions",
      "args": null,
      "concreteType": "EventCompetitionConnection",
      "kind": "LinkedField",
      "name": "__EventCompetitionsFragment_competitions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventCompetitionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventCompetition",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                {
                  "alias": "viewerCanDelete",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "action",
                      "value": "REMOVE_EVENT_COMPETITION"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "viewerCan",
                  "storageKey": "viewerCan(action:\"REMOVE_EVENT_COMPETITION\")"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "membersCanReadEvent",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Competition",
                  "kind": "LinkedField",
                  "name": "competition",
                  "plural": false,
                  "selections": [
                    (v1/*:: as any*/),
                    (v2/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    (v3/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "CompetitionCardFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "e16fec530d572a7017887993f27e36c5";

export default node;
